/**************************************************
 * Nombre:       Calentadario
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Badge, Grid} from "@mui/material";
import ano from '../../../../Recursos/2025.svg'
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {DateCalendar} from '@mui/x-date-pickers/DateCalendar';
import {PickersDay} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { es } from "dayjs/locale/es";
import ciruculo from '../../../../Recursos/ic_circulo.svg'
import {useEffect, useState} from "react";


const Calentadario = ({eventos, escogido, setEscogido}) => {
    dayjs.locale(es)


    const ServerDay = (props) => {
        const {highlightedDays = [], day, outsideCurrentMonth, ...other} = props;
        const [num,setNum] = useState(-1)


        const verificarDia = (day) => {

            let index = eventos.findIndex((e) => dayjs(e.fecha).format('YYYY-MM-DD') === day.format('YYYY-MM-DD'));
            return index

        }


        useEffect(() => {
            setNum(verificarDia(day))
        }, []);
        return (
            <Badge

                overlap="circular"
                badgeContent={num > -1 ? <img src={ciruculo} width={36} height={'auto'} style={{
                    marginLeft: -29,
                    marginBottom: -24,
                    zIndex: 1
                }}/> : ''}
            >
                <PickersDay
                    onClick={() => num > -1 ? setEscogido(eventos[num]) : '' }
                    {...other} outsideCurrentMonth={outsideCurrentMonth} day={day} sx={{zIndex: 2}}/>
            </Badge>
        );
    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 2, sm: 2, md: 2}} sx={{justifyContent: 'flex-start'}}>
                <img src={ano} width="100%" height="auto"/>
            </Grid>

            <Grid container size={{xs: 10, sm: 10, md: 10}} sx={{justifyContent: 'flex-start'}}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateCalendar views={['day']}
                                  slots={{
                                      day: ServerDay,
                                  }}


                    />
                </LocalizationProvider>
            </Grid>

        </Grid>
    )

}
export default Calentadario